// globals: jQuery

import CashFlowIframeDialog from './cashFlowIframeDialog';

const CashFlowFrameDialogRect = {
  width: '640',
  height: '620',
};

class CashFlowFrameDialogServiceBank {
  constructor() {
    this._cashFlowIframeDialog = new CashFlowIframeDialog();
    this._containerId = 'cashFlowFrameDialogFormContainer_Bank';
  }

  get cashFlowIframeDialog() {
    return this._cashFlowIframeDialog;
  }

  get containerId() {
    return this._containerId;
  }

  /**
     * @returns {*|jQuery|HTMLElement}
     */
  getContainer() {
    return jQuery(`#${this._containerId}`);
  }

  /**
     * @param callback
     * @param params
     */
  init(callback, params) {
    // this.isSuccess = false;
    jQuery(`<div id="${this._containerId}"></div>`).appendTo('body');
    const $cashFlowFrameDialogFormContainer_Bank = this.getContainer();
    const cashFlowIframeDialogOptions = params.cashFlowIframeDialogOptions ?? null;
    let options = {
      onDialogOpened: () => {
        this.cashFlowIframeDialog.onSuccess = (form, data) => {
          this.onSuccess(form, data);
          callback(form, data);
          const $formDialog = jQuery('#cashFlowFrameFormDialog');
          const $dialog = $formDialog.closest('.ca-dialog');
          $dialog.prev('.ui-widget-overlay').remove();
          $dialog.remove();
          $formDialog.remove();
        };
        this.cashFlowIframeDialog.onEmvSuccess = (data) => {
          this.onEmvSuccess(data);
          const $dialog = jQuery('#cashFlowFrameFormDialog').closest('.ca-dialog');
          $dialog.prev('.ui-widget-overlay').remove();
          $dialog.remove();
          jQuery('#cashFlowFrameFormDialog').remove();
        };
        this.cashFlowIframeDialog.init(cashFlowIframeDialogOptions);
      },
    };
    if (params) {
      if (params.dialogOptions) {
        params.dialogOptions.width = CashFlowFrameDialogRect.width;
        params.dialogOptions.height = CashFlowFrameDialogRect.height;
      }
      options = jQuery.extend(options, params);
    }
    $cashFlowFrameDialogFormContainer_Bank.cashFlowFrameDialogFormBank(options);
  }

  onEmvSuccess(data) {
    // stub method for subclasses
  }

  onSuccess(form, data) {
    // stub method for subclasses
  }

  /**
     * @param callback
     * @param params
     */
  open(callback, params) {
    this.init(callback, params);
    this.getContainer().cashFlowFrameDialogFormBank('openDialog');
  }
}

class CashFlowFrameDialogServiceBillingInfoBank extends CashFlowFrameDialogServiceBank {
  constructor() {
    super();

    jQuery.widget('ca.cashFlowFrameDialogFormBank', jQuery.ca.caDialogForm, {
      options: {
        dialog: null,
        form: null,
        formParams: {},
        formUrl: '/cash-flow/get-frame-form',
        dialogOptions: {
          title: '<b>Enter Bank Account to Store on File</b>',
          width: CashFlowFrameDialogRect.width,
          height: CashFlowFrameDialogRect.height,
          caProUI: true,
          staticForm: false,
        },
      },
    });
  }

  onSuccess(form, data) {
  }

  onEmvSuccess(data) {
    const { request } = data;
    const dataPrepared = {
      cc_merchant_unique_id: data.uniqueId.toString(),
      expiration_month: request.i4go_expirationmonth,
      expiration_year: request.i4go_expirationyear,
      cardConnect_expiry: request.i4go_expirationyear + request.i4go_expirationmonth,
    };

    const $form = jQuery('#paymentMethodEditForm');

    this.cashFlowIframeDialog.setCardConnectParamsToForm($form, dataPrepared, () => {});
    this.onSuccess(null, dataPrepared);
  }
}

class CashFlowFrameDialogServiceRefundBank extends CashFlowFrameDialogServiceBank {
  constructor() {
    super();
  }

  onSuccess(form, data) {
    const associationKeys = {
      cc_number: 'cc_number',
      cc_merchant_unique_id: 'cc_merchant_unique_id',
      cc_expirationyear: 'expiration_year',
      cc_expirationmonth: 'expiration_month',
    };

    jQuery.each(associationKeys, (key, item) => {
      if (!jQuery(`.credit-card-form input[name="${key}"]`).length) {
        jQuery('.credit-card-form').append(`<input type="hidden" name="${key}" value="${data[item]}">`);
      }
      jQuery(`.credit-card-form input[name="${key}"]`).attr('value', data[item]);
    });
  }
}

export {
  CashFlowFrameDialogServiceBank,
  CashFlowFrameDialogServiceBillingInfoBank,
  CashFlowFrameDialogServiceRefundBank,
};
